import { useMemo } from 'react';
import { wagerMutationKeys } from '../../../../lib/entry.js';
import { useMutationState } from '../../../../tanstack/entry.js';
/**
 * Checks if a coupon wager mutation is currently pending.
 *
 * @returns True if the last wager mutation is in pending state, false otherwise.
 */
export function useIsCouponWagerPending() {
  const mutationState = useMutationState(wagerMutationKeys.all);
  let t0;
  bb0: {
    mutationState.sort(_temp);
    const last = mutationState.at(-1);
    if (last) {
      t0 = last.status === "pending";
      break bb0;
    }
    t0 = false;
  }
  return t0;
}
function _temp(a, b) {
  return a.submittedAt - b.submittedAt;
}